import BasicList from '../BasicList';
import {get} from '../../utils/fetch';
import { backendServer } from '../../variable';

const requestList = async ({page, pageSize, ...params}) => {
  try {
    const result = await get(`${backendServer}/agent/sell/record/query`, {
      page,
      pageSize,
      ...params
    });
    return result;
  } catch (e) {
    throw e;
  }
};

// 出售记录列表
const sellList = new BasicList(requestList);
sellList.setListName('出售记录');

export default sellList;



// WEBPACK FOOTER //
// ./src/stores/SellList/index.js